export default __webpack_public_path__ + "static/media/020_start.first.cc751c19.png";